module.exports = __webpack_public_path__ + "static/img/77092H_R_02_20170815_LC.8c7e48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77092H_R_02_20170815_LC.png
// module id = gXLQ
// module chunks = 0